import { render, staticRenderFns } from "./CompareCartConfirm.vue?vue&type=template&id=36a2d6f3&scoped=true"
import script from "./CompareCartConfirm.vue?vue&type=script&lang=js"
export * from "./CompareCartConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2d6f3",
  null
  
)

export default component.exports